"use client";
import { useState } from "react";
import Breadcrumb from "@/components/Common/Breadcrumb";
import { getImagePath } from "@/lib/utils";
import Image from "next/image";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { HOW_IT_WORKS_PARTNER_TAB_ENABLED } from "@/components/constants/general";

const getYouTubeId = (url: string) => {
  const match = url.match(/embed\/([^?&]+)/);
  return match ? match[1] : "";
};

const HowItWork = () => {
  const t = useTranslations("howItWorks");
  const [activeTab, setActiveTab] = useState(HOW_IT_WORKS_PARTNER_TAB_ENABLED ? 0 : 1);
  const [playVideo, setPlayVideo] = useState(false);

  // const images = [
  //   getImagePath("/images/howitworks/Partners.png"),
  //   getImagePath("/images/howitworks/Producers.png"),
  //   getImagePath("/images/howitworks/Customers.png"),
  // ];
  const tabs = t.raw("tabs"); // [{ label, image, alt }, {…},{…}]

  // const tabLabels = ["PARTNER", "PRODUCER", "CUSTOMER"];
  const buttonColors = [
    "from-[#A23465] to-[#EA7F75]",    // Partner: blue
    "from-[#003399] to-[#0099CC]",    // Producer: pink
    "from-[#F26322] to-[#F78F2E]",    // Customer: yellow to red
  ];

  return (
    <section className="section-padding bg-white py-10 relative bg-cinema-dots">


      <div className="container mx-auto px-4 pt-16">
        <div className="w-full md:w-[75%] mx-auto items-center mb-2">

          {/* ------- TABS ------- */}
          <div className={`grid grid-cols-1 ${HOW_IT_WORKS_PARTNER_TAB_ENABLED ? "md:grid-cols-3" : "md:grid-cols-2"} gap-5 mt-0 w-full p-0 md:px-8 relative`}>
            {tabs.map((tab, idx) => (idx === 0 && !HOW_IT_WORKS_PARTNER_TAB_ENABLED) ? null : (
              <div key={idx} className="relative flex flex-col items-center">
                <Button
                  className={`w-full font-semibold px-6 sm:px-8 py-2 md:py-4
                           rounded-tl-md rounded-br-lg transition-colors
                           duration-300 bg-gradient-to-r ${buttonColors[idx]} text-white 
                           ${activeTab === idx
                      ? idx === 0
                        ? "ring-4 ring-[#A23465]/30"
                        : idx === 1
                          ? "ring-4 ring-[#003399]/30"
                          : "ring-4 ring-[#F26322]/30"
                      : ""}`}
                  onClick={() => { setActiveTab(idx); setPlayVideo(false); }}
                >
                  {tab.label} {/* 👉 LABEL FROM JSON */}
                </Button>

                {activeTab === idx && (
                  <span
                    className="block w-0 h-0 border-l-8 border-r-8 border-t-8 
                                     border-l-transparent border-r-transparent mx-auto"
                    style={{
                      borderTopColor:
                        idx === 0
                          ? "#A23465"
                          : idx === 1
                            ? "#003399"
                            : "#F26322"
                    }}
                  ></span>
                )}
              </div>
            ))}
          </div>

          {/* ------- VIDEO BLOCK (YouTube - click to play) ------- */}
          <div className="rounded-3xl mt-2 overflow-hidden bg-black">
            <div className="w-full aspect-video relative">
              {playVideo ? (
                <iframe
                  key={tabs[activeTab].videoUrl}
                  className="w-full h-full rounded-3xl"
                  src={tabs[activeTab].videoUrl + "?autoplay=1"}
                  title={tabs[activeTab].alt}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              ) : (
                <button
                  className="w-full h-full relative cursor-pointer group"
                  onClick={() => setPlayVideo(true)}
                  aria-label="Play video"
                >
                  <img
                    src={`https://img.youtube.com/vi/${getYouTubeId(tabs[activeTab].videoUrl)}/sddefault.jpg`}
                    alt={tabs[activeTab].alt}
                    className="w-full h-full object-cover rounded-3xl"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 md:w-20 md:h-20 bg-red-600 rounded-full flex items-center justify-center group-hover:bg-red-700 transition-colors shadow-lg">
                      <svg className="w-8 h-8 md:w-10 md:h-10 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                </button>
              )}
            </div>
          </div>




        </div>
      </div>
    </section>
  );
};

export default HowItWork;
